const BlogRelatedArticles = {
  parts: [
    'container',
    'containerInner',
    'title',
    'blogRelatedArticlesList'
  ],
  baseStyle: {
    container: {
      bg: 'white',
    },
    containerInner: {
      maxWidth: '1440px',
      mx: 'auto',
      display: 'flex',
      py: {base: 16, md: 20},
      pb: {base: 16, md: 30},
      px: {base: 0, md: 0},
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 6, md: 10}, // 40px mobile, 74px desktop
      alignSelf: 'stretch',
    },
    title: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90', // rgba(27, 26, 24, 0.90)
      fontFamily: 'heading',
      fontSize: {base: '28px', md: '40px'}, // 28px mobile, 40px desktop
      fontWeight: 'medium', // 500
      lineHeight: '120%',
      letterSpacing: {base: '-0.28px', md: '-0.4px'},
      flex: {base: 'none', md: '1 0 0'},
      px: {base: 5, md: 20},
      mb: 0,
    },
    blogRelatedArticlesList: {
      display: 'flex',
      pl: {base: 5, md: 20}, // 0 mobile (already padded by container), 80px desktop
      pr: {base: 0, md: 20},
      alignItems: 'center',
      gap: 1, // 4px from design
      alignSelf: 'stretch',
      position: 'relative',
      overflow: 'hidden',
      sx: {
        '.swiper': {
          overflow: {base: 'visible', md: 'hidden'},
          width: 'full',
        },
        ' .swiper-slide': {
          width: 'auto',
        },
      },
    },
  },
};

export default BlogRelatedArticles;
